import { render } from "./App.vue?vue&type=template&id=9009b69a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=9009b69a&lang=scss"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__